import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 400 }
  }

  connect() {
    this.timeoutId = null
  }

  disconnect() {
    this.clearTimer()
  }

  queueSubmit() {
    this.clearTimer()
    this.timeoutId = window.setTimeout(() => this.submitNow(), this.delayValue)
  }

  submitNow() {
    this.clearTimer()

    if (window.Turbo?.navigator?.submitForm) {
      window.Turbo.navigator.submitForm(this.element)
      return
    }

    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit()
      return
    }

    this.element.submit()
  }

  clearTimer() {
    if (!this.timeoutId) {
      return
    }

    window.clearTimeout(this.timeoutId)
    this.timeoutId = null
  }
}
